import Certificate from "../assets/certificate.svg";
import Tor from "../assets/tor.svg";
import Safari from "../assets/safari.svg";
import AuditIcon from "../components/shared/Layouts/sidebar/icons/Audit";
import LicenseIcon from "../components/shared/Layouts/sidebar/icons/License";
import ServiceControl from "../components/shared/Layouts/sidebar/icons/ServiceControl";
import ConfigIcon from "../components/shared/Layouts/sidebar/icons/Config";
import PolicyIcon from "../components/shared/Layouts/sidebar/icons/Policy";
import DiscoveryIcon from "../components/shared/Layouts/sidebar/icons/Discovery";
import EventsIcon from "../components/shared/Layouts/sidebar/icons/Events";
import Overview from "../components/shared/Layouts/sidebar/icons/Overview";
import ContractsIcon from "../components/shared/Layouts/sidebar/icons/Contracts";

import category_00 from "../assets/categories/-1.svg";
import category_0 from "../assets/categories/0.svg";
import category_1 from "../assets/categories/1.svg";
import category_2 from "../assets/categories/2.svg";
import category_3 from "../assets/categories/3.svg";
import category_4 from "../assets/categories/4.svg";
import category_5 from "../assets/categories/5.svg";
import category_6 from "../assets/categories/6.svg";
import category_7 from "../assets/categories/7.svg";
import category_8 from "../assets/categories/8.svg";
import category_9 from "../assets/categories/9.svg";
import category_10 from "../assets/categories/10.svg";
import category_11 from "../assets/categories/11.svg";
import category_12 from "../assets/categories/12.svg";
import category_13 from "../assets/categories/13.svg";
import category_14 from "../assets/categories/14.svg";
import category_15 from "../assets/categories/15.svg";
import category_16 from "../assets/categories/16.svg";
import category_17 from "../assets/categories/17.svg";
import category_18 from "../assets/categories/18.svg";
import category_19 from "../assets/categories/19.svg";
import category_20 from "../assets/categories/20.svg";
import category_21 from "../assets/categories/21.svg";
import category_22 from "../assets/categories/22.svg";
import category_23 from "../assets/categories/23.svg";
import category_24 from "../assets/categories/24.svg";
import category_25 from "../assets/categories/25.svg";
import category_26 from "../assets/categories/26.svg";
import category_27 from "../assets/categories/27.svg";
import category_29 from "../assets/categories/29.svg";
import category_30 from "../assets/categories/30.svg";
import category_31 from "../assets/categories/31.svg";
import category_32 from "../assets/categories/32.svg";
import category_33 from "../assets/categories/33.svg";
import category_34 from "../assets/categories/34.svg";
import category_35 from "../assets/categories/35.svg";
import category_36 from "../assets/categories/36.svg";
import category_37 from "../assets/categories/37.svg";
import category_38 from "../assets/categories/38.svg";
import category_71 from "../assets/categories/71.svg";
import category_72 from "../assets/categories/72.svg";
import ExtensionsIcon from "../components/shared/Layouts/sidebar/icons/Extensions";
import UptimeHealth from "../components/shared/Layouts/sidebar/icons/UptimeHealth";

export const DemoData = [
  {
    key: 0,
    icon: Certificate,
  },
  {
    key: 1,
    icon: Certificate,
  },
  {
    key: 2,
    icon: Certificate,
  },
];

export const BlockListData = [
  {
    key: 0,
    url: "192.168.5.69",
    status: "Blocked",
  },
  {
    key: 1,
    status: "Blocked",
    url: "192.168.5.5",
  },
  {
    key: 2,
    status: "Not Active",
    url: "192.168.5.10",
  },
];

export const IgnoreListData = [
  {
    key: 0,
    url: "www.google.com",
    status: "Allowed",
  },
  {
    key: 1,
    status: "Allowed",
    url: "www.facebook.com",
  },
  {
    key: 2,
    status: "Blocked",
    url: "192.168.5.5",
  },
];

export const BrowserListData = [
  {
    key: 0,
    url: "Tor",
    status: "Blocked",
    icon: Tor,
  },
  {
    key: 1,
    status: "Blocked",
    url: "Safari",
    icon: Safari,
  },
];

export const optionsData = [
  {
    value: 1,
    text: "Chrome",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="icon"
      >
        <path
          d="M11.9723 2.00179C11.9723 2.00179 17.8673 1.7374 20.9916 7.64056H11.471C11.471 7.64056 9.67291 7.58163 8.14016 9.75527C7.69812 10.6658 7.22662 11.6056 7.75708 13.4556C6.99078 12.1636 3.68945 6.43652 3.68945 6.43652C3.68945 6.43652 6.01828 2.23664 11.9723 2.00179Z"
          fill="#C6352E"
        />
        <path
          d="M20.6848 16.9896C20.6848 16.9896 17.9663 22.2081 11.2732 21.9516C12.0989 20.5275 16.0346 13.7368 16.0346 13.7368C16.0346 13.7368 16.9848 12.2149 15.8628 9.80543C15.2925 8.96855 14.7116 8.09162 12.8382 7.62406C14.3449 7.60916 20.9727 7.62502 20.9727 7.62502C20.9727 7.62502 23.4582 11.7347 20.6848 16.9896Z"
          fill="#F4D911"
        />
        <path
          d="M3.30187 17.0295C3.30187 17.0295 0.125621 12.0738 3.69555 6.427C4.52049 7.85159 8.45414 14.6435 8.45414 14.6435C8.45414 14.6435 9.30157 16.2244 11.9569 16.4611C12.9692 16.3876 14.022 16.3248 15.3651 14.9422C14.6246 16.2495 11.2965 21.961 11.2965 21.961C11.2965 21.961 6.48197 22.0504 3.30187 17.0295Z"
          fill="#81B354"
        />
        <path
          d="M11.2732 22.0002L12.6124 16.432C12.6124 16.432 14.0849 16.3176 15.3187 14.9683C14.5528 16.3108 11.2732 22.0002 11.2732 22.0002Z"
          fill="#7BAA50"
        />
        <path
          d="M7.48706 12.0624C7.48706 9.60782 9.48392 7.61792 11.9476 7.61792C14.4111 7.61792 16.4082 9.60777 16.4082 12.0624C16.4082 14.5172 14.4112 16.5071 11.9476 16.5071C9.48392 16.5071 7.48706 14.5172 7.48706 12.0624Z"
          fill="white"
        />
        <path
          d="M8.23364 12.0623C8.23364 10.0186 9.89637 8.36182 11.9477 8.36182C13.9986 8.36182 15.6615 10.0186 15.6615 12.0623C15.6615 14.1061 13.9986 15.763 11.9477 15.763C9.89637 15.7631 8.23364 14.106 8.23364 12.0623Z"
          fill="url(#paint0_linear_179_2310)"
        />
        <path
          d="M20.9727 7.62514L15.4583 9.23612C15.4583 9.23612 14.6267 8.0202 12.8381 7.62418C14.3879 7.61892 20.9727 7.62514 20.9727 7.62514Z"
          fill="#E7CE12"
        />
        <path
          d="M7.64992 13.2559C6.87494 11.9186 3.6897 6.43652 3.6897 6.43652L7.77467 10.4629C7.77467 10.4629 7.35488 11.3234 7.51405 12.5523L7.64992 13.2559Z"
          fill="#BC332C"
        />
        <defs>
          <linearGradient
            id="paint0_linear_179_2310"
            x1="11.9476"
            y1="8.41416"
            x2="11.9476"
            y2="15.5416"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#A2C0E6" />
            <stop offset="1" stop-color="#406CB1" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    value: 2,
    text: "Firefox",
    icon: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="icon"
      >
        <path
          d="M16.1595 1.92139C15.6573 2.50625 15.4227 3.82438 15.9326 5.159C16.4415 6.49458 17.2229 6.20457 17.7095 7.56635C18.3522 9.36265 18.0526 11.7768 18.0526 11.7768C18.0526 11.7768 18.8252 14.0144 19.3632 11.6371C20.5536 7.17353 16.1595 3.02128 16.1595 1.92139Z"
          fill="url(#paint0_radial_500_3561)"
        />
        <path
          d="M10.0291 20.4576C15.1736 20.4576 19.3409 16.2646 19.3409 11.0958C19.3409 5.92712 15.1736 1.73413 10.034 1.73413C4.89438 1.73413 0.727068 5.92615 0.727068 11.0958C0.717374 16.2704 4.88953 20.4576 10.0291 20.4576Z"
          fill="url(#paint1_radial_500_3561)"
        />
        <path
          d="M17.0066 16.8679C16.805 17.0105 16.5937 17.1376 16.3746 17.2491C16.6654 16.8233 16.9339 16.382 17.1782 15.9271C17.3769 15.7069 17.5582 15.4936 17.7065 15.2627C17.7783 15.1492 17.8597 15.0096 17.946 14.8466C18.4684 13.9038 19.0452 12.3791 19.0617 10.8127V10.8088C19.0617 10.77 19.0627 10.7312 19.0617 10.6934C19.0646 10.3006 19.0239 9.90776 18.9415 9.52367C18.9454 9.55374 18.9493 9.58381 18.9531 9.61387C18.9483 9.5906 18.9444 9.56732 18.9396 9.54404C18.9473 9.58671 18.9531 9.62842 18.9599 9.66916C19.0665 10.576 18.9909 11.4616 18.61 12.1134C18.6042 12.1231 18.5974 12.1318 18.5916 12.1415C18.7893 11.1502 18.8552 10.0552 18.6352 8.95917C18.6352 8.95917 18.547 8.42669 17.8926 6.80885C17.5165 5.87772 16.8477 5.11439 16.2564 4.55863C15.7387 3.91751 15.2676 3.48686 15.0088 3.21431C14.4669 2.644 14.2401 2.21626 14.147 1.93692C14.0666 1.89618 13.0322 0.891343 12.9498 0.853516C12.4981 1.5538 11.079 3.74292 11.7546 5.78946C12.0609 6.71671 12.8345 7.67887 13.6439 8.21912C13.6798 8.25986 14.1257 8.74482 14.338 9.8389C14.5571 10.9689 14.4417 11.8505 13.9909 13.1551C13.4607 14.2996 12.1016 15.4305 10.8289 15.5459C8.10882 15.7933 7.11231 14.1793 7.11231 14.1793C8.08459 14.5682 9.15865 14.4868 9.81297 14.0833C10.4721 13.6759 10.8705 13.3733 11.1933 13.4926C11.5123 13.6109 11.7662 13.2666 11.5384 12.9097C11.1788 12.3558 10.5235 12.0697 9.87307 12.1842C9.2139 12.2918 8.60998 12.8137 7.74531 12.3083C7.68909 12.2763 7.6348 12.2404 7.58342 12.2016C7.52623 12.1638 7.76857 12.2589 7.71235 12.2162C7.54465 12.125 7.24705 11.9252 7.1695 11.8544C7.1569 11.8428 7.30037 11.9 7.2868 11.8883C6.47932 11.223 6.58013 10.7729 6.60533 10.4907C6.62569 10.2647 6.77206 9.97565 7.01925 9.85829C7.13848 9.92328 7.21313 9.97371 7.21313 9.97371C7.21313 9.97371 7.16175 9.86993 7.13461 9.81465C7.1443 9.81077 7.15303 9.81174 7.16272 9.80786C7.26063 9.85538 7.47679 9.97759 7.59118 10.0523C7.73949 10.157 7.78699 10.2501 7.78699 10.2501C7.78699 10.2501 7.82577 10.2288 7.79669 10.1376C7.78602 10.0998 7.74143 9.98147 7.59409 9.8612L7.60281 9.86217C7.69102 9.91261 7.77439 9.96984 7.85194 10.0348C7.89362 9.88448 7.96826 9.72638 7.95178 9.44511C7.94209 9.24724 7.94597 9.19584 7.91107 9.11921C7.88005 9.05326 7.92852 9.02804 7.9828 9.09593C7.97311 9.04259 7.9576 8.99021 7.93627 8.94075V8.9359C8.00413 8.7002 9.36803 8.08624 9.4669 8.01447C9.62976 7.89905 9.76644 7.75065 9.86822 7.578C9.94383 7.45676 10.001 7.28702 10.0146 7.02999C10.0224 6.84474 9.93608 6.72059 8.55667 6.57607C8.17959 6.53921 7.95857 6.26569 7.83255 6.01351C7.80929 5.9592 7.78602 5.90973 7.76276 5.86027C7.74046 5.80304 7.72204 5.74387 7.70944 5.68374C7.9353 5.03583 8.31336 4.48782 8.87074 4.07366C8.90079 4.04554 8.74957 4.08045 8.77962 4.0533C8.81549 4.02129 9.0462 3.92818 9.08982 3.90684C9.14314 3.88162 8.86202 3.76232 8.61289 3.79142C8.35989 3.81954 8.3056 3.85058 8.17086 3.90781C8.22708 3.85155 8.40545 3.77881 8.36377 3.77881C8.0904 3.82051 7.75209 3.97958 7.46128 4.15902C7.46032 4.12798 7.4671 4.09694 7.47873 4.06785C7.34399 4.12507 7.0115 4.35688 6.91553 4.55378C6.91941 4.51595 6.92135 4.47812 6.92135 4.4403C6.81859 4.52662 6.72553 4.62361 6.64411 4.7303L6.63926 4.73515C5.85601 4.41896 5.16582 4.39859 4.58226 4.5402C4.45431 4.41217 4.39227 4.50528 4.10146 3.86707C4.08207 3.82827 4.11697 3.9049 4.10146 3.86707C4.05396 3.74292 4.13054 4.03196 4.10146 3.86707C3.6129 4.2531 2.97021 4.68957 2.66195 4.998C2.65807 5.01061 3.02158 4.89519 2.66195 4.998C2.53593 5.03389 2.54465 5.10857 2.52527 5.78558C2.52042 5.83699 2.5243 5.89421 2.52042 5.94077C2.2742 6.25502 2.1065 6.52078 2.04252 6.65851C1.7236 7.20846 1.37269 8.0649 1.03244 9.41989C1.18269 9.05229 1.363 8.69826 1.57335 8.3617C1.29029 9.08138 1.01693 10.2104 0.962646 11.9495C1.03147 11.5906 1.11871 11.2356 1.22534 10.8864C1.15846 12.3297 1.40759 13.77 1.95431 15.1066C2.15012 15.5857 2.47389 16.3122 3.02449 17.1094C4.75578 18.9319 7.19762 20.0667 9.90215 20.0667C12.7288 20.0667 15.2647 18.8311 17.0066 16.8679Z"
          fill="url(#paint2_linear_500_3561)"
        />
        <path
          d="M14.9176 18.192C18.3346 17.7963 19.8468 14.2735 17.9042 14.2037C16.1497 14.1484 13.2988 18.3792 14.9176 18.192Z"
          fill="url(#paint3_radial_500_3561)"
        />
        <path
          d="M18.1507 13.4848C20.5014 12.1162 19.8888 9.15894 19.8888 9.15894C19.8888 9.15894 18.9814 10.2132 18.3649 11.8941C17.7561 13.5585 16.7373 14.3112 18.1507 13.4848Z"
          fill="url(#paint4_radial_500_3561)"
        />
        <path
          d="M10.6874 19.9415C13.9648 20.988 16.7818 18.4041 15.0456 17.5419C13.4665 16.764 9.1325 19.4468 10.6874 19.9415Z"
          fill="url(#paint5_radial_500_3561)"
        />
        <path
          d="M18.3947 14.74C18.4742 14.6275 18.5818 14.2667 18.6778 14.1057C19.2565 13.1707 19.2604 12.4258 19.2604 12.4093C19.6103 10.6624 19.5783 9.94955 19.3631 8.63045C19.1896 7.56839 18.4335 6.04657 17.7782 5.31428C17.1026 4.55968 17.5785 4.80507 16.9242 4.25415C16.3513 3.61788 15.7949 2.9884 15.4924 2.73525C13.3046 0.905005 13.354 0.516065 13.3957 0.45011C13.3889 0.457869 13.3782 0.469508 13.3647 0.485027C13.3385 0.381245 13.3201 0.294922 13.3201 0.294922C13.3201 0.294922 12.1239 1.49181 11.8728 3.485C11.708 4.78664 12.1956 6.14357 12.9003 7.01165C13.2677 7.46072 13.6826 7.86906 14.1382 8.22891V8.22793C14.6714 8.99321 14.9641 9.93791 14.9641 10.9544C14.9641 13.4995 12.9013 15.5625 10.3567 15.5625C10.0097 15.5625 9.6646 15.5237 9.32629 15.4471C8.12524 15.2182 7.43214 14.612 7.08608 14.2007C6.88833 13.965 6.80399 13.7934 6.80399 13.7934C7.87999 14.1794 9.06941 14.0979 9.79255 13.6983C10.5215 13.2939 10.9626 12.9941 11.3203 13.1125C11.6731 13.2298 11.9542 12.8884 11.7022 12.5344C11.455 12.1804 10.8123 11.6741 9.85847 11.8147C9.12854 11.9214 8.45967 12.4393 7.50388 11.9369C7.44184 11.9049 7.38271 11.87 7.32454 11.8312C7.26154 11.7943 7.52908 11.8875 7.46704 11.8458C7.28092 11.7556 6.95134 11.5577 6.86603 11.4879C6.85149 11.4762 7.01047 11.5334 6.99593 11.5218C6.10217 10.8613 6.21365 10.4161 6.24176 10.1358C6.26406 9.91172 6.42691 9.6256 6.70027 9.50921C6.83211 9.57419 6.9145 9.62366 6.9145 9.62366C6.9145 9.62366 6.85828 9.52084 6.82726 9.46556C6.83792 9.46168 6.84858 9.46265 6.85828 9.45877C6.96685 9.50533 7.20628 9.62754 7.3323 9.70125C7.49612 9.80503 7.54847 9.89814 7.54847 9.89814C7.54847 9.89814 7.59209 9.87681 7.5601 9.7866C7.54847 9.74975 7.49903 9.63142 7.33618 9.51212L7.34587 9.51308C7.44281 9.56255 7.5349 9.61978 7.62117 9.68476C7.66673 9.53539 7.74913 9.37924 7.73168 9.0999C7.72102 8.90397 7.72586 8.85257 7.68709 8.77691C7.65219 8.71193 7.70648 8.68671 7.76658 8.75363C7.75591 8.70029 7.73943 8.64888 7.7152 8.59942L7.71617 8.59457C7.79081 8.36081 9.30109 7.75267 9.41062 7.6809C9.58802 7.56936 9.73924 7.42193 9.85459 7.24831C9.93893 7.12804 10.0019 6.96024 10.0174 6.70515C10.0223 6.58973 9.9874 6.49953 9.58705 6.41224C9.34665 6.35986 8.97538 6.30942 8.40345 6.25511C7.98565 6.21825 7.74137 5.94667 7.60178 5.69643C7.57658 5.64212 7.55041 5.59362 7.52423 5.54512C7.5 5.4879 7.47964 5.4297 7.4651 5.36957C7.71617 4.7139 8.16596 4.15522 8.75242 3.7721C8.78635 3.74494 8.61768 3.77889 8.65161 3.75173C8.69038 3.71973 8.9463 3.62758 8.99477 3.60624C9.0539 3.58103 8.74176 3.4627 8.46743 3.49179C8.18728 3.51992 8.12815 3.54999 7.9779 3.60721C8.03994 3.55193 8.23769 3.47918 8.19116 3.48015C7.88872 3.52186 7.51357 3.67899 7.19271 3.85746C7.19174 3.82642 7.19853 3.79538 7.2121 3.76725C7.06281 3.82448 6.69542 4.05435 6.58879 4.2493C6.59364 4.21245 6.59558 4.17462 6.59461 4.13679C6.48216 4.22118 6.37941 4.3172 6.28829 4.42389L6.28247 4.42874C5.41489 4.11545 4.652 4.09509 4.00543 4.23573C3.8639 4.10867 3.63707 3.91565 3.31524 3.28326C3.29294 3.24543 3.28131 3.36182 3.26483 3.324C3.13978 3.03399 3.06417 2.55873 3.07677 2.23186C3.07677 2.23186 2.81795 2.34922 2.60469 2.84194C2.56495 2.93021 2.53974 2.97967 2.51454 3.02817C2.50291 3.04272 2.54071 2.86619 2.5349 2.87589C2.49806 2.93894 2.40112 3.0272 2.35944 3.14068C2.33036 3.22506 2.28965 3.27259 2.26347 3.37734L2.25766 3.38704C2.25572 3.356 2.26541 3.25901 2.25863 3.27938C2.15878 3.48209 2.07251 3.6916 2.00078 3.90595C1.88542 4.28519 1.75165 4.80022 1.73032 5.47141C1.72547 5.52184 1.72935 5.57907 1.72547 5.62466C1.45308 5.936 1.26696 6.19982 1.19717 6.33658C0.84335 6.87974 0.454634 7.72939 0.0775494 9.07274C0.24525 8.70611 0.445909 8.35402 0.676619 8.02328C0.363513 8.73618 0.0610702 9.85644 0 11.5819C0.0756107 11.225 0.173517 10.8729 0.29081 10.5276C0.236526 11.678 0.370299 13.1037 1.09732 14.7129C1.52869 15.6595 2.5223 17.5809 4.94959 19.0804C7.37689 20.5799 5.77549 19.6954 7.19465 20.1561C7.29934 20.1939 7.40597 20.2317 7.51454 20.2676C7.48158 20.254 7.44862 20.2395 7.41566 20.2249C8.3608 20.5082 9.34083 20.6527 10.3276 20.6527C14.0025 20.6556 15.0863 19.1794 15.0863 19.1794C15.0863 19.1794 15.0824 19.1823 15.0756 19.1871C15.127 19.1386 15.1774 19.0872 15.2259 19.0348C14.6462 19.5828 13.323 19.6187 12.8276 19.5799C13.671 19.3316 14.2264 19.1221 15.3063 18.708C15.4323 18.6614 15.5622 18.6081 15.6941 18.5479C15.7086 18.5421 15.7231 18.5344 15.7367 18.5285C15.7629 18.5159 15.7891 18.5053 15.8152 18.4917C16.3416 18.2434 16.836 17.934 17.2896 17.5683C18.3744 16.7012 18.6099 15.8564 18.734 15.2997C18.7166 15.353 18.6632 15.4772 18.6254 15.5586C18.3463 16.1561 17.7268 16.5237 17.0541 16.838C17.374 16.418 17.6706 15.9805 17.943 15.5276C18.1621 15.3103 18.2309 14.9689 18.3947 14.74Z"
          fill="url(#paint6_radial_500_3561)"
        />
        <path
          d="M17.0746 16.8127C17.5166 16.3248 17.9141 15.7671 18.2146 15.1337C18.9891 13.5052 20.1853 10.7972 19.2431 7.96987C18.4976 5.73516 17.4749 4.51306 16.177 3.31908C14.0676 1.3802 13.4782 0.51503 13.4782 0C13.4782 0 11.0432 2.71676 12.0988 5.54894C13.1545 8.38112 15.3181 8.27831 16.7489 11.2346C18.4327 14.7138 15.386 18.51 12.8666 19.5731C13.0207 19.5391 18.4666 18.3054 18.7535 15.189C18.7477 15.2462 18.6246 16.1075 17.0746 16.8127Z"
          fill="url(#paint7_radial_500_3561)"
        />
        <path
          d="M10.0186 6.70329C10.0273 6.51901 9.93134 6.39583 8.41041 6.25325C7.7842 6.19505 7.54476 5.61698 7.47206 5.37256C7.24911 5.9516 7.15799 6.55781 7.20743 7.29301C7.24135 7.77409 7.56415 8.29009 7.71828 8.59368C7.71828 8.59368 7.75221 8.54906 7.76869 8.53257C8.0595 8.22996 9.27799 7.76827 9.39237 7.70232C9.51742 7.62278 9.99823 7.27167 10.0186 6.70329Z"
          fill="url(#paint8_linear_500_3561)"
        />
        <path
          d="M3.32106 3.28431C3.29877 3.24648 3.28714 3.36287 3.27066 3.32505C3.14561 3.03504 3.07 2.56559 3.08745 2.23291C3.08745 2.23291 2.82862 2.35027 2.61536 2.84299C2.57562 2.93126 2.55042 2.98072 2.52521 3.02922C2.51358 3.04377 2.55139 2.86724 2.54557 2.87694C2.50873 2.93999 2.4118 3.02825 2.37011 3.13688C2.33522 3.22611 2.30032 3.27364 2.27318 3.38421C2.26542 3.41428 2.28093 3.25133 2.27415 3.2717C1.77686 4.23386 1.68186 5.68778 1.73421 5.62668C2.79276 4.49574 4.00641 4.22708 4.00641 4.22708C3.87845 4.13105 3.59733 3.85656 3.32106 3.28431Z"
          fill="url(#paint9_linear_500_3561)"
        />
        <path
          d="M7.33906 15.1154C5.87628 14.4907 4.21382 13.6091 4.27586 11.6071C4.36116 8.97088 6.73321 9.49173 6.73321 9.49173C6.64402 9.51307 6.40459 9.68378 6.31929 9.86612C6.2301 10.0931 6.06628 10.6062 6.56163 11.1445C7.34003 11.9883 4.96314 13.1464 8.63123 15.3336C8.72429 15.3831 7.77237 15.3026 7.33906 15.1154Z"
          fill="url(#paint10_linear_500_3561)"
        />
        <path
          d="M6.81964 13.801C7.85687 14.1618 9.0647 14.0988 9.78882 13.6992C10.2735 13.4295 10.8939 12.997 11.2768 13.1036C10.9462 12.9727 10.6952 12.9116 10.3937 12.897C10.3423 12.897 10.2813 12.8961 10.225 12.8903C10.1145 12.8903 10.004 12.8961 9.89448 12.9087C9.70739 12.9261 9.50092 13.0435 9.31286 13.0251C9.30317 13.0241 9.4951 12.9455 9.47959 12.9494C9.37975 12.9698 9.27118 12.9746 9.15679 12.9892C9.08409 12.9969 9.02108 13.0066 8.94935 13.0096C6.78862 13.1929 4.9633 11.8379 4.9633 11.8379C4.80723 12.3607 5.65834 13.3966 6.81964 13.801Z"
          fill="url(#paint11_linear_500_3561)"
        />
        <path
          d="M17.0706 16.8262C19.2556 14.6797 20.3616 12.0706 19.8934 9.14341C19.8934 9.14341 20.0805 10.6439 19.3719 12.1793C19.7121 10.6807 19.7519 8.81848 18.8484 6.89027C17.6426 4.31609 15.6592 2.96208 14.9012 2.39661C13.7544 1.54017 13.2785 0.669176 13.2697 0.48877C12.9266 1.191 11.8903 3.59932 13.1583 5.67302C14.3467 7.61578 16.2186 8.19288 17.5282 9.97463C19.9429 13.2588 17.0706 16.8262 17.0706 16.8262Z"
          fill="url(#paint12_linear_500_3561)"
        />
        <path
          d="M16.7575 11.2413C15.9936 9.66327 15.0407 8.97463 14.1392 8.22778C14.2439 8.37424 14.2701 8.42662 14.3282 8.52167C15.1221 9.36744 16.2922 11.4324 15.442 14.0231C13.8426 18.9008 7.44668 16.6041 6.77588 15.9591C7.0473 18.7815 11.7691 20.1326 14.8439 18.3024C16.5936 16.6448 18.0089 13.8281 16.7575 11.2413Z"
          fill="url(#paint13_linear_500_3561)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_500_3561"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(19.0557 5.16461) rotate(2.55631) scale(7.21439 10.6102)"
          >
            <stop offset="0.045" stop-color="#FFEA00" />
            <stop offset="0.12" stop-color="#FFDE00" />
            <stop offset="0.254" stop-color="#FFBF00" />
            <stop offset="0.429" stop-color="#FF8E00" />
            <stop offset="0.769" stop-color="#FF272D" />
            <stop offset="0.872" stop-color="#E0255A" />
            <stop offset="0.953" stop-color="#CC2477" />
            <stop offset="1" stop-color="#C42482" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_500_3561"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(13.911 4.0534) scale(20.3331 20.3448)"
          >
            <stop stop-color="#00CCDA" />
            <stop offset="0.22" stop-color="#0083FF" />
            <stop offset="0.261" stop-color="#007AF9" />
            <stop offset="0.33" stop-color="#0060E8" />
            <stop offset="0.333" stop-color="#005FE7" />
            <stop offset="0.438" stop-color="#2639AD" />
            <stop offset="0.522" stop-color="#401E84" />
            <stop offset="0.566" stop-color="#4A1475" />
          </radialGradient>
          <linearGradient
            id="paint2_linear_500_3561"
            x1="11.3418"
            y1="15.3055"
            x2="7.32162"
            y2="2.16215"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#000F43" stop-opacity="0.4" />
            <stop offset="0.485" stop-color="#001962" stop-opacity="0.173" />
            <stop offset="1" stop-color="#002079" stop-opacity="0" />
          </linearGradient>
          <radialGradient
            id="paint3_radial_500_3561"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(16.9546 10.618) rotate(5.67298) scale(6.85835 6.86223)"
          >
            <stop offset="0.003" stop-color="#FFEA00" />
            <stop offset="0.497" stop-color="#FF272D" />
            <stop offset="1" stop-color="#C42482" />
          </radialGradient>
          <radialGradient
            id="paint4_radial_500_3561"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(16.9871 4.0086) rotate(5.67293) scale(11.453 11.4594)"
          >
            <stop offset="0.003" stop-color="#FFE900" />
            <stop offset="0.157" stop-color="#FFAF0E" />
            <stop offset="0.316" stop-color="#FF7A1B" />
            <stop offset="0.472" stop-color="#FF4E26" />
            <stop offset="0.621" stop-color="#FF2C2E" />
            <stop offset="0.762" stop-color="#FF1434" />
            <stop offset="0.892" stop-color="#FF0538" />
            <stop offset="1" stop-color="#FF0039" />
          </radialGradient>
          <radialGradient
            id="paint5_radial_500_3561"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(17.5501 14.7394) rotate(5.67292) scale(10.5093 10.5152)"
          >
            <stop offset="0.003" stop-color="#FF272D" />
            <stop offset="0.497" stop-color="#C42482" />
            <stop offset="0.986" stop-color="#620700" />
          </radialGradient>
          <radialGradient
            id="paint6_radial_500_3561"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(15.0033 8.27064) scale(16.4086 16.4181)"
          >
            <stop offset="0.156" stop-color="#FFEA00" />
            <stop offset="0.231" stop-color="#FFDE00" />
            <stop offset="0.365" stop-color="#FFBF00" />
            <stop offset="0.541" stop-color="#FF8E00" />
            <stop offset="0.763" stop-color="#FF272D" />
            <stop offset="0.796" stop-color="#F92433" />
            <stop offset="0.841" stop-color="#E91C45" />
            <stop offset="0.893" stop-color="#CF0E62" />
            <stop offset="0.935" stop-color="#B5007F" />
          </radialGradient>
          <radialGradient
            id="paint7_radial_500_3561"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(13.7689 0.026663) scale(19.3757 19.3868)"
          >
            <stop offset="0.279" stop-color="#FFEA00" />
            <stop offset="0.402" stop-color="#FFDD00" />
            <stop offset="0.63" stop-color="#FFBA00" />
            <stop offset="0.856" stop-color="#FF9100" />
            <stop offset="0.933" stop-color="#FF6711" />
            <stop offset="0.994" stop-color="#FF4A1D" />
          </radialGradient>
          <linearGradient
            id="paint8_linear_500_3561"
            x1="0.384659"
            y1="8.08214"
            x2="7.84051"
            y2="6.95113"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#C42482" stop-opacity="0.5" />
            <stop offset="0.474" stop-color="#FF272D" stop-opacity="0.5" />
            <stop offset="0.486" stop-color="#FF2C2C" stop-opacity="0.513" />
            <stop offset="0.675" stop-color="#FF7A1A" stop-opacity="0.72" />
            <stop offset="0.829" stop-color="#FFB20D" stop-opacity="0.871" />
            <stop offset="0.942" stop-color="#FFD605" stop-opacity="0.964" />
            <stop offset="1" stop-color="#FFE302" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_500_3561"
            x1="3.00447"
            y1="5.412"
            x2="2.15741"
            y2="2.37711"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#891551" stop-opacity="0.6" />
            <stop offset="1" stop-color="#C42482" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_500_3561"
            x1="4.62604"
            y1="9.84609"
            x2="6.36781"
            y2="12.2748"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.005" stop-color="#891551" stop-opacity="0.5" />
            <stop offset="0.484" stop-color="#FF272D" stop-opacity="0.5" />
            <stop offset="1" stop-color="#FF272D" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_500_3561"
            x1="7.95055"
            y1="14.1056"
            x2="8.10878"
            y2="12.5439"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#C42482" />
            <stop offset="0.083" stop-color="#C42482" stop-opacity="0.81" />
            <stop offset="0.206" stop-color="#C42482" stop-opacity="0.565" />
            <stop offset="0.328" stop-color="#C42482" stop-opacity="0.362" />
            <stop offset="0.447" stop-color="#C42482" stop-opacity="0.204" />
            <stop offset="0.562" stop-color="#C42482" stop-opacity="0.091" />
            <stop offset="0.673" stop-color="#C42482" stop-opacity="0.023" />
            <stop offset="0.773" stop-color="#C42482" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_500_3561"
            x1="13.0176"
            y1="0.757698"
            x2="19.4358"
            y2="15.1016"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFF14F" />
            <stop offset="0.268" stop-color="#FFEE4C" />
            <stop offset="0.452" stop-color="#FFE643" />
            <stop offset="0.612" stop-color="#FFD834" />
            <stop offset="0.757" stop-color="#FFC41E" />
            <stop offset="0.892" stop-color="#FFAB02" />
            <stop offset="0.902" stop-color="#FFA900" />
            <stop offset="0.949" stop-color="#FFA000" />
            <stop offset="1" stop-color="#FF9100" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_500_3561"
            x1="14.2837"
            y1="9.0087"
            x2="11.2433"
            y2="17.1675"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF8E00" />
            <stop offset="0.04" stop-color="#FF8E00" stop-opacity="0.858" />
            <stop offset="0.084" stop-color="#FF8E00" stop-opacity="0.729" />
            <stop offset="0.13" stop-color="#FF8E00" stop-opacity="0.628" />
            <stop offset="0.178" stop-color="#FF8E00" stop-opacity="0.557" />
            <stop offset="0.227" stop-color="#FF8E00" stop-opacity="0.514" />
            <stop offset="0.282" stop-color="#FF8E00" stop-opacity="0.5" />
            <stop offset="0.389" stop-color="#FF8E00" stop-opacity="0.478" />
            <stop offset="0.524" stop-color="#FF8E00" stop-opacity="0.416" />
            <stop offset="0.676" stop-color="#FF8E00" stop-opacity="0.314" />
            <stop offset="0.838" stop-color="#FF8E00" stop-opacity="0.172" />
            <stop offset="1" stop-color="#FF8E00" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
];

export const sideBarData = (isDnsAvailable) => [
  {
    icon: (isActive) => <Overview isActive={isActive} />,
    text: 'Overview',
    path: '/overview',
    isMenu: false,
    testId: 'overview',
    dnsPanelRequired: false,
    ffSaasVisRequired: false
  },
  {
    icon: (isActive) => <EventsIcon isActive={isActive} />,
    text: 'Events & Traffic',
    path: '/events',
    isMenu: false,
    testId: 'events',
    dnsPanelRequired: false,
    ffSaasVisRequired: false,
  },
  // {
  //   icon: (isActive) => <EventsIcon isActive={isActive} />,
  //   text: 'Events',
  //   path: null,
  //   isMenu: true,
  //   expandKey: 'events',
  //   testId: 'events',
  //   dnsPanelRequired: false,
  //   ffSaasVisRequired: false,
  //   subItems: [
  //     {
  //       text: 'Detections',
  //       path: '/events/detection',
  //       testId: 'detction_events_menu',
  //       dnsPanelRequired: false,
  //       ffSaasVisRequired: false
  //     },
  //     {
  //       text: 'Restrictions',
  //       path: '/events/restriction',
  //       testId: 'restriction_events_menu',
  //       dnsPanelRequired: true,
  //       ffSaasVisRequired: false
  //     }
  //   ]
  // },
  {
    icon: (isActive) => <DiscoveryIcon isActive={isActive} />,
    text: 'Discovery',
    path: null,
    isMenu: true,
    expandKey: 'visibility',
    testId: 'visibility',
    dnsPanelRequired: false,
    ffSaasVisRequired: true,
    subItems: [
      {
        text: 'SaaS control',
        path: '/visibility/saas',
        testId: 'saas-control-menu',
        dnsPanelRequired: false,
        ffSaasVisRequired: true
      },
      // Traffic records moved to Events page as a view toggle
      // {
      //   text: 'Traffic records',
      //   path: '/visibility/traffic',
      //   testId: 'traffic-records-menu',
      //   dnsPanelRequired: false,
      //   ffSaasVisRequired: true
      // },
      // old ext page
      // {
      //   text: 'Extensions',
      //   path: '/visibility/ext',
      //   testId: 'ext-menu',
      //   dnsPanelRequired: true,
      //   ffSaasVisRequired: true
      // }
      {
        text: 'Extensions',
        path: '/visibility/ext',
        testId: 'extensions',
        dnsPanelRequired: true,
        ffSaasVisRequired: true,
      },
      {
        text: 'Browser Health',
        path: '/browser-health',
        testId: 'browser-health-menu',
        dnsPanelRequired: true,
        ffSaasVisRequired: false,
      },
    ]
  },
  // {
  //   icon: (isActive) => <ExtensionsIcon isActive={isActive} />,
  //   text: 'Extensions',
  //   path: '/extension',
  //   isMenu: false,
  //   testId: 'extensions',
  //   dnsPanelRequired: false,
  //   ffSaasVisRequired: false,
  // },
  {
    icon: (isActive) => <PolicyIcon isActive={isActive} />,
    text: 'Policy and web control',
    path: null,
    isMenu: true,
    expandKey: 'policy',
    testId: 'policy-menu',
    dnsPanelRequired: false,
    ffSaasVisRequired: false,
    subItems: [
      {
        text: 'Browser Protection',
        path: isDnsAvailable ? '/policy/browser' : '/policy/browser_pr',
        testId: isDnsAvailable ? 'browser-protection-menu' : 'policy_browser_pr',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      },
      {
        text: 'URL Filtering',
        path: '/policy/urlfilter',
        testId: 'url-filtering',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      },
      {
        text: 'File Scan',
        path: '/policy/filescan',
        testId: 'file-scan',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'Browser Extensions',
        path: '/policy/ext',
        testId: 'browser-extension',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'Data Loss Prevention',
        path: '/policy/dlp',
        testId: 'data-loss-prevention',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'Correlation Policy',
        path: '/policy/correlation',
        testId: 'correlation-policy',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'User Awareness',
        path: '/policy/awareness',
        testId: 'user-awareness',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'Access Control',
        path: '/policy/accesscontrol',
        testId: 'access-control',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'CDR',
        path: '/policy/cdr',
        testId: 'cdr',
        cdrPanelRequired: true,
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      }
    ]
  },
  {
    icon: (isActive) => <ConfigIcon isActive={isActive} />,
    text: 'Config',
    path: null,
    isMenu: true,
    expandKey: 'config',
    testId: 'config-menu',
    dnsPanelRequired: false,
    ffSaasVisRequired: false,
    subItems: [
      {
        text: 'AD Sync',
        path: '/config/ldap',
        testId: 'ad-sync',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'SIEM',
        path: '/config/siem',
        testId: 'siem-menu',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      },
      {
        text: 'Certificate management',
        path: '/certificates',
        testId: 'cert-menu',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      },
      {
        text: 'Branding',
        path: '/config/brand',
        testId: 'brand-menu',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      },
      {
        text: 'Managers & API Keys',
        path: '/config/admins',
        testId: 'admin-menu',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      },
      {
        text: 'Backup & Restore',
        path: '/config/backup',
        testId: 'backup-menu',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      },
      {
        text: 'Authentication',
        path: '/config/auth',
        testId: 'auth-menu',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'Policy Objects',
        path: '/config/pol_objects',
        testId: 'config_policy_objects',
        dnsPanelRequired: false,
        ffSaasVisRequired: false
      }
    ]
  },
  {
    icon: (isActive) => <ServiceControl isActive={isActive} />,
    text: 'Service Control',
    path: '/config/pac',
    isMenu: false,
    expandKey: null,
    testId: 'service-control-menu',
    dnsPanelRequired: true,
    mobileOverride: true,
    ffSaasVisRequired: false
  },
  {
    icon: (isActive) => <LicenseIcon isActive={isActive} />,
    text: 'License',
    path: null,
    isMenu: true,
    expandKey: 'license',
    dnsPanelRequired: true,
    ffSaasVisRequired: false,
    testId: 'license',
    subItems: [
      {
        text: 'Registered Users',
        path: '/license/users',
        testId: 'registered-user',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      },
      {
        text: 'Installers',
        path: '/license/installers',
        testId: 'installers',
        dnsPanelRequired: true,
        ffSaasVisRequired: false
      }
    ]
  },
  {
    icon: (isActive) => <ContractsIcon isActive={isActive} />,
    text: 'BYOD & Contractors',
    path: '/contractors',
    isMenu: false,
    expandKey: null,
    testId: 'contractors-menu',
    dnsPanelRequired: true,
    ffSaasVisRequired: false
  },
  {
    icon: (isActive) => <AuditIcon isActive={isActive} />,
    text: 'Audit',
    path: '/logs/audit',
    isMenu: false,
    expandKey: null,
    testId: 'audit-menu',
    dnsPanelRequired: false,
    ffSaasVisRequired: false
  },
  {
    icon: (isActive) => <UptimeHealth isActive={isActive} />,
    text: 'Service Health',
    path: '/config/uptime',
    isMenu: false,
    expandKey: null,
    testId: 'config_uptime_monitoring',
    dnsPanelRequired: false,
    ffSaasVisRequired: false,
    uptimeFlagRequired: true
  }
]
export const VIEW_TABLE = {
  '/overviewv3': 'fullView',
  '/events': 'fullView',
  '/events/detection': 'fullView',
  '/events/restriction': 'fullView',
  '/overview': 'fullView',
  '/policy': 'fullView',
  '/policy/proxy': 'fullView',
  '/policy/appcontrol': 'fullView',
  '/policy/ignoreurl': 'fullView',
  '/policy/blockurl': 'fullView',
  '/policy/urlfilter': 'fullView',
  '/policy/filescan': 'fullView',
  '/visibility/saas': 'fullView',
  '/visibility/ext': 'fullView',
  '/extension': 'fullView',
  '/policy/ext': 'fullView',
  '/policy/dlp': 'fullView',
  '/policy/correlation': 'fullView',
  '/policy/browser': 'fullView',
  '/policy/awareness': 'fullView',
  '/policy/accesscontrol': 'fullView',
  '/policy/browser_pr': 'fullView',
  '/policy/cdr': 'fullView',
  '/config/ldap': 'fullView',
  '/config/siem': 'fullView',
  '/config/sso': 'fullView',
  '/license/users': 'fullView',
  '/config/pac': 'fullView',
  '/config/backup': 'fullView',
  '/config/auth': 'fullView',
  '/config/pol_objects': 'fullView',
  '/config/brand': 'fullView',
  '/config/admins': 'fullView',
  '/certificates': 'fullView',
  '/license/installers': 'fullView',
  '/logs/audit': 'fullView',
  '/login': 'basicView',
  '/ldap': 'fullView',
  '/': 'fullView',
  '/contractors': 'fullView',
  '/config/uptime': 'fullView',
};

export const keysToCheckForLocalStorage = [
  'restric_usernameFilter',
  'restric_agentFilter',
  'restric_typeFilter',
  'event_usernameFilter',
  'event_agentFilter',
  'event_verdictFilter',
  'event_typeFilter',
  'audit_usernameFilter',
  'audit_ipFilter',
  'audit_agentFilter',
  'audit_actionFilter',
  'audit_emailsFilter',
  'audit_statusFilter',
  'traffic_usernameFilter',
  'traffic_domainFilter',
  'traffic_ipFilter',
  'traffic_methodFilter',
  'traffic_versionFilter',
  'traffic_statusFilter',
  'traffic_useragentFilter',
  'traffic_tlsverFilter',
  'traffic_CNFilter',
  'traffic_certIssuerFilter',
  'traffic_refererFilter',
  'traffic_websiteFilter',
  'saas_userFilter'
];

export const METADATA_KEY = 'metaData';

/**
 * Flatten sidebar items (including subItems) that have a path.
 * Mirrors CollapsibleSidebar visibility flags so route guards stay in sync with nav.
 */
export function flattenSideBarNavItems(isDnsAvailable = true) {
  const items = [];
  sideBarData(isDnsAvailable).forEach((item) => {
    if (item.path) items.push(item);
    if (item.subItems?.length) {
      item.subItems.forEach((subItem) => {
        if (subItem.path) items.push(subItem);
      });
    }
  });
  return items;
}

/**
 * Whether a nav item would be shown given current meta flags.
 * Logic matches CollapsibleSidebar.jsx.
 */
export function isNavItemVisible(item, { dnsPanel, mobilePanel, cdrPanel, upTimeFlag, ffSaasVis } = {}) {
  if (!item) return true;
  if (item.ffSaasVisRequired && !ffSaasVis) return false;
  if (item.dnsPanelRequired && !dnsPanel && !(item.mobileOverride && mobilePanel)) return false;
  if (item.cdrPanelRequired && !cdrPanel) return false;
  if (item.uptimeFlagRequired && !upTimeFlag) return false;
  return true;
}

function pathMatchesNavItem(pathname, navPath) {
  if (!pathname || !navPath) return false;
  return pathname === navPath || pathname.startsWith(`${navPath}/`);
}

/**
 * Returns false when the path is hidden from the nav for the current meta
 * (e.g. dns=true and dnsPanelRequired pages like /policy/filescan).
 * Paths not present in sideBarData are allowed.
 * /policy/browser and /policy/browser_pr are both allowed so BrowserPolicyRoute can redirect.
 */
export function isPathAllowedByMeta(pathname, metaData) {
  let meta = metaData;
  if (meta == null) {
    try {
      meta = JSON.parse(localStorage.getItem(METADATA_KEY) || '{}');
    } catch {
      meta = {};
    }
  }

  const dnsPanel = !meta?.dns;
  const flags = {
    dnsPanel,
    mobilePanel: !!meta?.mobile,
    cdrPanel: !!meta?.cdr,
    upTimeFlag: !!meta?.ui_show_uptime,
    ffSaasVis: !!(typeof window !== 'undefined' && window.config?.ff_saas_vis),
  };

  // Collect paths from both DNS and full-panel sidebar variants (browser path differs).
  const navItems = [
    ...flattenSideBarNavItems(true),
    ...flattenSideBarNavItems(false),
  ];

  let matched = null;
  let matchedLen = -1;
  navItems.forEach((item) => {
    if (pathMatchesNavItem(pathname, item.path) && item.path.length > matchedLen) {
      matched = item;
      matchedLen = item.path.length;
    }
  });

  if (!matched) return true;
  return isNavItemVisible(matched, flags);
}

let metadataLoadedThisSession = false;

export function markMetadataLoadedThisSession() {
  metadataLoadedThisSession = true;
}

export function clearMetadataLoadedThisSession() {
  metadataLoadedThisSession = false;
}

export function isMetadataLoadedThisSession() {
  return metadataLoadedThisSession;
}
/** Overview V3 selected date range — cleared on logout. */
export const OVERVIEW_V3_DATE_RANGE_KEY = 'overviewV3_date_range';

export const CustomFiltersTestDefaultProps = {
  filters: [
    {
      id: 'agents',
      title: 'agents',
      filterType: 'array',
      isActive: false,
      isOpen: false,
      localStorageKey: 'eventV2_agents',
      filters: [
        {
          fid: 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Safari/537.36',
          title:
            'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Safari/537.36',
          checked: false
        }
      ]
    },
    {
      id: 'types',
      title: 'types',
      filterType: 'array',
      isActive: false,
      isOpen: false,
      localStorageKey: 'eventV2_types',
      filters: [
        {
          fid: 'Website Blocked By Policy > News, Weather, Info',
          title: 'Website Blocked By Policy > News, Weather, Info',
          checked: false
        }
      ]
    },
    {
      id: 'users',
      title: 'users',
      filterType: 'array',
      isActive: false,
      isOpen: false,
      localStorageKey: 'eventV2_users',
      filters: [
        {
          fid: 'no-x-forward-username',
          title: 'no-x-forward-username',
          checked: false
        }
      ]
    },
    {
      id: 'verdict',
      title: 'verdict',
      filterType: 'array',
      isActive: true,
      isOpen: false,
      localStorageKey: 'eventV2_verdict',
      filters: [
        {
          fid: 'Notify',
          title: 'Notify',
          checked: false
        },
        {
          fid: 'Blocked',
          title: 'Blocked',
          checked: true
        },
        {
          fid: 'Detected',
          title: 'Detected',
          checked: true
        }
      ]
    },
    {
      id: 'domain',
      title: 'domain',
      filterType: 'select',
      isActive: false,
      isOpen: false,
      localStorageKey: 'eventV2_domain',
      filters: [
        {
          fid: 'all',
          title: 'all',
          checked: false
        },
        {
          fid: 'redaccess.io',
          title: 'redaccess.io',
          checked: true
        }
      ]
    },
    {
      id: 'date_picker',
      localStorageKey: 'eventV2_date_picker',
      filterType: 'date_picker',
      isActive: false,
      isOpen: false,
      title: 'Date',
      value: {
        start_date: '2022-12-28T12:06:56.000Z',
        end_date: new Date().toISOString()
      },
      filters: []
    },
    {
      id: 'url',
      localStorageKey: 'eventV2_websiteFilter',
      filterType: 'string',
      isActive: false,
      title: 'Url',
      value: '',
      filters: []
    },
    {
      id: 'referer',
      localStorageKey: 'eventV2_refererFilter',
      filterType: 'string',
      isActive: false,
      title: 'Referer',
      value: '',
      filters: []
    }
  ],
  autoTriggerApiCall: true,
  filterMapping: {
    eventV2_users: 'users',
    eventV2_agents: 'agents',
    'eventV2_user agent': 'user agent',
    'eventV2_user agents': 'user agents',
    eventV2_websiteFilter: 'url',
    eventV2_refererFilter: 'referer',
    eventV2_verdict: 'verdict',
    eventV2_types: 'types',
    eventV2_startDate: 'start_date',
    eventV2_endDate: 'end_date',
    eventV2_date_picker: 'date_picker'
  },
  defaultFilters: {
    verdict: ['Blocked', 'Detected']
  }
};
export const CSV_LIMIT_KEY = {
  'events': 70000,
  'audit': 60000,
  'traffic': 10000,
  'browser_health': 10000
};
export const category_list = [
    { name: "Phishing and Scams", id: -1, selected: true, icon:category_00 },
    { name: "Not Safe For Work", id: 0, selected: true, icon:category_0 },
    { name: "Illegal or Harmful", id: 1, selected: true, icon:category_1 },
    { name: "Arts & Entertainment", id: 2, selected: false, icon:category_2 },
    { name: "Home & Garden", id: 3, selected: false, icon:category_3 },
    { name: "Law, Gov & Politics", id: 4, selected: false, icon:category_4 },
    { name: "News, Weather, Info", id: 5, selected: false, icon:category_5 },
    { name: "Personal Finance", id: 6, selected: false, icon:category_6 },
    { name: "Society", id: 7, selected: false, icon:category_7 },
    { name: "Science", id: 8, selected: false, icon:category_8 },
    { name: "Pets", id: 9, selected: false, icon:category_9 },
    { name: "Sports", id: 10, selected: false, icon:category_10 },
    { name: "Style & Fashion", id: 11, selected: false, icon:category_11 },
    { name: "Technology & Computing", id: 12, selected: false, icon:category_12 },
    { name: "Automotive", id: 13, selected: false, icon:category_13 },
    { name: "Travel", id: 14, selected: false, icon:category_14 },
    { name: "Real Estate", id: 15, selected: false, icon:category_15 },
    { name: "Shopping", id: 16, selected: false, icon:category_16 },
    { name: "Religion & Spirituality", id: 17, selected: false, icon:category_17 },
    { name: "General", id: 18, selected: false, icon:category_18 },
    { name: "Business", id: 19, selected: false, icon:category_19 },
    { name: "Careers", id: 20, selected: false, icon:category_20 },
    { name: "Education", id: 21, selected: false, icon:category_21 },
    { name: "Family & Parenting", id: 22, selected: false, icon:category_22 },
    { name: "Health & Fitness", id: 23, selected: false, icon:category_23 },
    { name: "Food & Drink", id: 24, selected: false, icon:category_24 },
    { name: "Hobbies & Interests", id: 25, selected: false, icon:category_25 },
    { name: "SAAS", id: 26, selected: false, icon:category_26 },
    { name: "Ads", id: 27, selected: false, icon:category_27 },
    { name: "Files Sharing", id: 29, selected: false, icon:category_29 },
    { name: "Proxies", id: 30, selected: false, icon:category_30 },
    { name: "AI Chat", id: 31, selected: false, icon:category_31, beta: true },
    { name: "AI Generative Code", id: 32, selected: false, icon:category_32, beta: true },
    { name: "AI Writing Assistant", id: 33, selected: false, icon:category_33, beta: true },
    { name: "Social Networks", id: 34, selected: false, icon:category_34 },
    { name: "Web Mail", id: 35, selected: false, icon:category_35 },
    { name: "Instant Messaging", id: 36, selected: false, icon:category_36 },
    { name: "Online Streaming", id: 37, selected: false, icon:category_37 },
    { name: "Dynamic DNS", id: 38, selected: false, icon:category_38 },
    { name: "Low Reputation", id: 71, selected: false, icon:category_71 },
    { name: "Newly Registered", id: 72, selected: false, icon:category_72 },
  ];

  export const deprecatedCategoryList = [
    { name: "Not Safe For Work", id: 0, selected: false},
    { name: "AI Chat", id: 31, selected: false},
    { name: "AI Generative Code", id: 32, selected: false},
    { name: "AI Writing Assistant", id: 33, selected: false},
  ];